import { YodaColors } from 'yoda-ui/yodaTheme';

export const sideContainerStyle = {
  firstBox: {
    backgroundColor: YodaColors.white60,
  },
};
